import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "section__title--white" }, "Contact", -1)
const _hoisted_2 = { class: "contact__form" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Message sent! ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Thanks for your interest in Steamcord. A team member will be with you shortly. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_text_area = _resolveComponent("base-text-area")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: "contact section",
      id: "contact",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_1,
      _createElementVNode("form", _hoisted_2, [
        _createVNode(_component_base_input, {
          class: "full-width",
          placeholder: "Email",
          error: _ctx.contactErrors.emailError,
          modelValue: _ctx.contactData.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactData.email) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["error", "modelValue"]),
        _createVNode(_component_base_text_area, {
          class: "full-width",
          rows: "8",
          placeholder: "Your message",
          error: _ctx.contactErrors.messageError,
          modelValue: _ctx.contactData.message,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactData.message) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["error", "modelValue"]),
        _withDirectives(_createElementVNode("p", { class: "form__error" }, _toDisplayString(_ctx.formError), 513), [
          [_vShow, _ctx.formError]
        ]),
        _createVNode(_component_loading_button, {
          "button-type": "button--black",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _withDirectives(_createVNode(_component_modal, {
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSuccess = false))
    }, {
      title: _withCtx(() => [
        _hoisted_4
      ]),
      message: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showSuccess]
    ])
  ], 64))
}